


























import { Component, Prop, Vue } from 'vue-property-decorator';
import Logo from './Logo.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { get } from 'lodash';

import CloseIcon from './CloseIcon.vue';

import { PeriodicElement, BonusPeriodicElement } from '../data';

@Component({
  components: { CloseIcon, Logo },
  computed: {
    ...mapGetters(['selectedElement']),
    ...mapState(['isFirstPage']),
  },
  methods: mapMutations(['markFirstPage']),
})
export default class Header extends Vue {
  private selectedElement?: PeriodicElement | BonusPeriodicElement;
  private isFirstPage: boolean = this.isFirstPage;

  private markFirstPage: () => void = this.markFirstPage;

  get headerColor() {
    return get(this.selectedElement || {}, 'colorClass');
  }

  get smallHeaderText() {
    return 'The Elements of';
  }

  get bigHeaderText() {
    return 'Basketball';
  }

  private handleClose() {
    if (this.isFirstPage) {
      this.markFirstPage();
      this.$router.replace('/');
    } else {
      this.$router.go(-1);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header.vue